import { render, staticRenderFns } from "./AppContactDocumentField.vue?vue&type=template&id=97042ed6&scoped=true"
import script from "./AppContactDocumentField.vue?vue&type=script&lang=js"
export * from "./AppContactDocumentField.vue?vue&type=script&lang=js"
import style0 from "./AppContactDocumentField.vue?vue&type=style&index=0&id=97042ed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97042ed6",
  null
  
)

export default component.exports